import { applyMiddleware, combineReducers, createStore } from "redux"
import authorization, { effects as authEffects, authActions } from "./authorization"

export const store = createStore(combineReducers({ authorization }), applyMiddleware(authEffects))

export type RootState = ReturnType<typeof store.getState>

export { authActions }
